// Applied only when KioskSessionLifecycle is enabled — see kioskPersistTransform.js.
// timesheetMode is intentionally omitted so check-in vs check-out preference persists.
export default {
  status: 'inactive',
  opportunity: null,
  volunteers: [],
  volunteeringRoles: [],
  hasWaivers: false,
  error: null,
  'getVolunteers.running': false,
  'getVolunteers.error': null,
  'signUpVolunteer.running': false,
  'signUpVolunteer.error': null,
  'checkIn.running': false,
  'checkIn.error': null,
  'checkOut.running': false,
  'checkOut.error': null,
  'getWaivers.running': false,
  'getWaivers.error': null,
  'search.query': '',
  'search.results': [],
  'search.loading': false,
  'search.error': null,
}
